// extracted by mini-css-extract-plugin
export default {"wrapper":"bHRDA","infos":"ymm0t","content":"i9A4b"};